import { render, staticRenderFns } from "./StatsFittingSales.vue?vue&type=template&id=3337dbc3&"
import script from "./StatsFittingSales.vue?vue&type=script&lang=js&"
export * from "./StatsFittingSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports